var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mySlider"},[_c('owl-carousel',{attrs:{"msg":"This is owl carousel page","data":_vm.data,"items":_vm.items,"margin":_vm.margin,"loop":_vm.loop,"autoplay":_vm.autoplay,"nav":_vm.nav,"navText":_vm.navText}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }